import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-geolocalizacion',
    templateUrl: './geolocalizacion.component.html',
    styleUrls: ['./geolocalizacion.component.css'],
    standalone: false
})
export class GeolocalizacionComponent {

  group: FormGroup


}
